exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image__input[data-v-70acda5c]{display:none}.image__preview[data-v-70acda5c]{width:80px;height:80px;border:1px solid #e2e2e2;border-radius:10px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;align-items:center;justify-content:center;overflow:hidden;cursor:pointer}.image__preview span[data-v-70acda5c]{font-size:13px;color:#999;text-align:center}.image__preview img[data-v-70acda5c]{width:100%;height:100%}", ""]);

// exports
